import { render, staticRenderFns } from "./ListaVenta.vue?vue&type=template&id=67f3e328"
import script from "./ListaVenta.vue?vue&type=script&lang=js"
export * from "./ListaVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports